<template>
  <div class="recycle-class-component">
    <div class="recycle-class-content">
      <div>
        <img class="icon-class-title" src="./img/icon_class_title.png" />
      </div>
      <div class="class-list">
        <div
          v-for="(item, index) in classList"
          :key="index"
          class="class-item"
        >
          <img class="icon-class" :src="item.icon" />
          <div class="class-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      classList: [
        { name: '手机', icon: require('./img/icon_class_phone.png') },
        { name: '平板', icon: require('./img/icon_class_pad.png') },
        { name: '笔记本', icon: require('./img/icon_class_book.png') },
        { name: '耳机', icon: require('./img/icon_class_ear.png') },
        { name: '智能手表', icon: require('./img/icon_class_watch.png') },
        { name: '智能手环', icon: require('./img/icon_class_wristband.png') },
        { name: '相机', icon: require('./img/icon_class_camera.png') },
        { name: '无人机', icon: require('./img/icon_class_drone.png') }
      ]
    };
  }
};
</script>

<style scoped>
.recycle-class-content {
  padding: 100px 0;
  text-align: center;
  .icon-class-title {
    width: 261px;
    height: 64px;
  }
  .class-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 30px;
    margin: 0 auto;
    width: 684px;
    .class-item {
      margin-top: 30px;
      margin-right: 100px;
      text-align: center;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .icon-class {
        width: 96px;
        height: 96px;
      }
      .class-name {
        margin-top: 10px;
        line-height: 20px;
        font-size: 14px;
        color: #2c2c2c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/recycle-class.vue